import React from 'react';
import '../../styles/table-main/main.css';

const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className='my-heading'>Ph.D. Abstract</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th width="5%" align="center" scope="col">
                                                    {" "}
                                                    S.NO.
                                                </th>
                                                <th width="9%" align="center" scope="col">
                                                    FILE NO.{" "}
                                                </th>
                                                <th width="38%" scope="col">
                                                    STUDENT NAME
                                                </th>
                                                <th width="33%" scope="col">
                                                    SUBJECT
                                                </th>
                                                <th width="15%" scope="col">
                                                    VIEW ABSTRACT
                                                </th>
                                            </tr>
                                            <tr>
                                                <td align="center"> 1</td>
                                                <td align="center">2827</td>
                                                <td>VAGESH KUMAR BHARDWAJ</td>
                                                <td> DRAWING</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/2827.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">2</td>
                                                <td align="center">2874</td>
                                                <td>NEHA BHAT</td>
                                                <td>MUSIC</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/2874.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">3</td>
                                                <td align="center">2877</td>
                                                <td>VIKASH RAJ</td>
                                                <td>FINE ARTS</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/2877.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">4</td>
                                                <td align="center">3015</td>
                                                <td>AVANEESH KUMAR</td>
                                                <td> COMMERCE BUS. ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3015.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">5</td>
                                                <td align="center">3016</td>
                                                <td>MOHD. SHOEB</td>
                                                <td>COMMERCE BUS. ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3016.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td height={27} align="center">
                                                    6
                                                </td>
                                                <td align="center">3088</td>
                                                <td>SHIDHARTH SHALET</td>
                                                <td> HISTORY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3088.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">7</td>
                                                <td align="center">3121</td>
                                                <td>RITA VERMA</td>
                                                <td>MUSIC</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3121.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">8</td>
                                                <td align="center">3164</td>
                                                <td>PAYAL</td>
                                                <td>GEOGRAPHY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3164.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">9</td>
                                                <td align="center">3169</td>
                                                <td>MONUPAL THESIS</td>
                                                <td>COMMERCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3169.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">10</td>
                                                <td align="center">3172</td>
                                                <td>RUCHIKA RATHOR</td>
                                                <td>COMMERCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3172.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">11</td>
                                                <td align="center">3173</td>
                                                <td>BHAVNA GUPTA</td>
                                                <td>COMMERCE BUS. ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3173.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">12</td>
                                                <td align="center">3178</td>
                                                <td>SHIVRAJ</td>
                                                <td>SOCIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3178.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">13</td>
                                                <td align="center">3183</td>
                                                <td>BRIJIES QADAR</td>
                                                <td>SOCIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3183.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">14</td>
                                                <td align="center">3192</td>
                                                <td>SANJAY SINGH YADAV</td>
                                                <td>COMMERCE BUS. ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3192.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">15</td>
                                                <td align="center">3193</td>
                                                <td>RAVIKANT SARAL</td>
                                                <td>HINDI</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3193.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">16</td>
                                                <td align="center">3202</td>
                                                <td>NISHA RANA</td>
                                                <td>MICROBIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3202.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">17</td>
                                                <td align="center">3206</td>
                                                <td>ARVIND SIROHI</td>
                                                <td>SOCIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3206.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">18</td>
                                                <td align="center">3207</td>
                                                <td>SACHIN KUMAR</td>
                                                <td>HISTORY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3207.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">19</td>
                                                <td align="center">3208</td>
                                                <td>MADHULIKA</td>
                                                <td>EDUCATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3208.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">20</td>
                                                <td align="center">3220</td>
                                                <td>PREETI VIKAL</td>
                                                <td>COMMERCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3220.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">21</td>
                                                <td align="center">3221</td>
                                                <td>J.S NEGI</td>
                                                <td>DEFENCE STUDIES</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3221.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">22</td>
                                                <td align="center">3222</td>
                                                <td>ASTHA PRATAP</td>
                                                <td>ENGLISH</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3222.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">23</td>
                                                <td align="center">3223</td>
                                                <td>VIJANDER SINGH RANA</td>
                                                <td>HISTORY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3223.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">24</td>
                                                <td align="center">3224</td>
                                                <td>SACHIN KUMAR </td>
                                                <td>HISTORY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3224.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">25</td>
                                                <td align="center">3225</td>
                                                <td>LALIT KUMAR SARSHVT</td>
                                                <td>HINDI</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3225.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">26</td>
                                                <td align="center">3227</td>
                                                <td>VAISHALI</td>
                                                <td>STATISTICS</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3227.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">27</td>
                                                <td align="center">3228</td>
                                                <td>RENU LATA</td>
                                                <td>LAW</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3228.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">28</td>
                                                <td align="center">3247</td>
                                                <td>NEELAM SAGAR</td>
                                                <td>BOTANY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3247.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">29</td>
                                                <td align="center">3250</td>
                                                <td>CHANCHAL TYAGI</td>
                                                <td>EDUCATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3250.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">30</td>
                                                <td align="center">3251</td>
                                                <td>REENA SINGH</td>
                                                <td>COMMERCE &amp; BUSINESS ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3251.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">31</td>
                                                <td align="center">3253</td>
                                                <td>NEHA BISHT</td>
                                                <td>MICROBIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3253.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">32</td>
                                                <td align="center">3255</td>
                                                <td>RICHA AGARWAL</td>
                                                <td>COMMERCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3255.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">33</td>
                                                <td align="center">3256</td>
                                                <td>RAAM KUMAR</td>
                                                <td>GEOGRAPHY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3256.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">34</td>
                                                <td align="center">3257</td>
                                                <td>SHANTONU ROY</td>
                                                <td>DEFENCE STUDIES</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3257.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">35</td>
                                                <td align="center">3258</td>
                                                <td>REKHA</td>
                                                <td>POLITICAL SCIENCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3258.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">36</td>
                                                <td align="center">3259</td>
                                                <td>GAJENDRA PAL</td>
                                                <td>LAW</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3259.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">37</td>
                                                <td align="center">3262</td>
                                                <td>ISHA TYAGI</td>
                                                <td>ENGLISH</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3262.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">38</td>
                                                <td align="center">3265</td>
                                                <td>CHARU BANSAL</td>
                                                <td>EDUCATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3265.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">39</td>
                                                <td align="center">3268</td>
                                                <td>HINA QAMAR</td>
                                                <td>ZOOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3268.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">40</td>
                                                <td align="center">3277</td>
                                                <td>RICHA VATS</td>
                                                <td>COMMERCE &amp; BUSINESS ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3277.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">41</td>
                                                <td align="center">3278</td>
                                                <td>VARSHA RANI</td>
                                                <td>TOXICOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3278.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">42</td>
                                                <td align="center">3281</td>
                                                <td>SUMIT KUMAR</td>
                                                <td>POLITICAL SCIENCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3281.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">43</td>
                                                <td align="center">3288</td>
                                                <td>KAVITA RANI</td>
                                                <td>SOCIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3288.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">44</td>
                                                <td align="center">3289</td>
                                                <td>ANSUIYA NAIN</td>
                                                <td>POLITICAL SCIENCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3289.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">45</td>
                                                <td align="center">3292</td>
                                                <td>JAIDA DHAM</td>
                                                <td>GEOGRAPHY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3292.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">46</td>
                                                <td align="center">3299</td>
                                                <td>SANTOSH KUMAR</td>
                                                <td>POLITICAL SCIENCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3299.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={5} align="center" />
                                            </tr>
                                            <tr>
                                                <td align="center">47</td>
                                                <td align="center">3131</td>
                                                <td>ALKA SHARMA</td>
                                                <td>COMMERCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3131.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">48</td>
                                                <td align="center">--</td>
                                                <td>MANNI PANDAY</td>
                                                <td>---</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/MANNI.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">49</td>
                                                <td align="center">3168</td>
                                                <td>SURKSHA</td>
                                                <td>DRAWING &amp; PAINTING</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3168.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">50</td>
                                                <td align="center">--</td>
                                                <td>LOKESH KUMAR</td>
                                                <td>EDUCATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/LOKESH.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">51</td>
                                                <td align="center">3226</td>
                                                <td>ANUJ BAWARA</td>
                                                <td>ENGLISH</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3226.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">52</td>
                                                <td align="center">3180</td>
                                                <td>VAISHALI JAIN</td>
                                                <td>ENGLISH LITERATURE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3180.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">53</td>
                                                <td align="center">3195</td>
                                                <td>PRAGTI</td>
                                                <td>HINDI</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3195.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">54</td>
                                                <td align="center">2928</td>
                                                <td>RITU GARG </td>
                                                <td>HOME SCIENCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/2928.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">55</td>
                                                <td align="center">3176</td>
                                                <td>VERTIKA AGARWAL</td>
                                                <td>COMMERCE &amp; BUSINESS ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3176.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">56</td>
                                                <td align="center">3142</td>
                                                <td>RAVI KUMAR BAKSHI</td>
                                                <td>COMMERCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3142.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">57</td>
                                                <td align="center">3144</td>
                                                <td>SNEHA SHARMA </td>
                                                <td>COMMERCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3144.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">58</td>
                                                <td align="center">--</td>
                                                <td>RAVINDRA KUMAR</td>
                                                <td>COMMERCE &amp; BUSINESS ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/RAVINDRA.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">59</td>
                                                <td align="center">3248</td>
                                                <td>SWATI SHARMA</td>
                                                <td>COMMERCE &amp; BUSINESS ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3248.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">60</td>
                                                <td align="center">3151</td>
                                                <td>VINAY PAL SINGH </td>
                                                <td>COMMERCE </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3151.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">61</td>
                                                <td align="center">3219</td>
                                                <td>SWATI JAIN </td>
                                                <td>COMMERCE &amp; BUSINESS ADMINISTRATION</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3219.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">62</td>
                                                <td align="center">--</td>
                                                <td>REENU</td>
                                                <td>SOCIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/REENU.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">63</td>
                                                <td align="center">3200</td>
                                                <td>ALPNA POSWAL</td>
                                                <td>HISTORY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3200.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">64</td>
                                                <td align="center">3245</td>
                                                <td>ABHISHEK PRIYADARSHI</td>
                                                <td>HISTORY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3245.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">65</td>
                                                <td align="center">3119</td>
                                                <td>SHALINI GUPTA</td>
                                                <td>MUSIC</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3119.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">66</td>
                                                <td align="center">2640</td>
                                                <td>ABIDA PARVEEN</td>
                                                <td>LAW</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/2640.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">67</td>
                                                <td align="center">3212</td>
                                                <td>NEHA GARG</td>
                                                <td>SOCIOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3212.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">68</td>
                                                <td align="center">--</td>
                                                <td>REETU GOEL</td>
                                                <td>STATISTICS</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/REETU.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">69</td>
                                                <td align="center">3196</td>
                                                <td>LALIT KUMAR</td>
                                                <td>STATISTICS</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3196.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">70</td>
                                                <td align="center">3235</td>
                                                <td>PRAVEEN KUMAR</td>
                                                <td>GEOGRAPHY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3235.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">71</td>
                                                <td align="center">3197</td>
                                                <td>RAMPAL </td>
                                                <td>POLITICAL SCIENCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3197.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">72</td>
                                                <td align="center">3174</td>
                                                <td>VIJAY KUMAR</td>
                                                <td>POLITICAL SCIENCE</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3174.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">73</td>
                                                <td align="center">3246</td>
                                                <td>SHEETAL CHAUDHARY</td>
                                                <td>--</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3246.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">74</td>
                                                <td align="center">--</td>
                                                <td>NEHA CHOUDHARY</td>
                                                <td>STATISTICS</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/NEHA.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">75</td>
                                                <td align="center">--</td>
                                                <td>ANUPMA</td>
                                                <td>ZOOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/ANUPMA.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">76</td>
                                                <td align="center">3232</td>
                                                <td>AASHA</td>
                                                <td>--</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3232.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">77</td>
                                                <td align="center">3231</td>
                                                <td>SAMYADAS</td>
                                                <td>--</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3231.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">78</td>
                                                <td align="center">3201</td>
                                                <td>NEETU NIMESH </td>
                                                <td>ZOOLOGY</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3201.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">79</td>
                                                <td align="center">3237</td>
                                                <td>SARIPALLI GAUTAM MURTY</td>
                                                <td>GENETICS &amp; PLANT BREEDING</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3237.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">80</td>
                                                <td align="center">3244</td>
                                                <td>TINKU GAUTAM</td>
                                                <td>GENETICS &amp; PLANT BREEDING</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3244.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">81</td>
                                                <td align="center">3908</td>
                                                <td>KALPNA JAIN</td>
                                                <td>PHYSICS</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/abstract-21/3908.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;